// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { getDate as fn } from "../getDate.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const getDateWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default getDateWithOptions;
